import React from "react";
import { ReactComponent as IconArrow } from "../../../../assets/icons/arrow.svg";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function SectionMainTitle() {
  const { t } = useTranslation();
  return (
    <section className="ads-section-main-title">
      <h1 className="ads-section-main-title__title">{t("name_game")}</h1>
      <div className="ads-section-main-title__navigate-buy">
        <IconArrow className="flow-arrow" />
      </div>
    </section>
  );
}
